import React from 'react';
import { CARD } from '../ui';
import StatTile from '../dashboard/StatTile';
import { formatMonthLong, plural } from './format';

// What a manager sees: the plan their company is on and their own team's
// footprint this month. No money — the bill is the admins' to see — and
// nothing about the rest of the company.
const TeamUsageView = ({ data }) => {
  const { team, plan, period, state } = data;
  const planLine = plan
    ? state === 'trial'
      ? `${data.company.name} is on a free trial of the ${plan.name} plan.`
      : `${data.company.name} is on the ${plan.name} plan.`
    : `${data.company.name} isn't on a plan yet.`;

  return (
    <div className="space-y-6">
      <div className={`${CARD} p-6`}>
        <p className="text-white font-medium">{planLine}</p>
        <p className="text-sm text-gray-400 mt-1">
          Every active account on your team is a seat, and guest submissions beyond the plan's monthly allowance are
          billed. Invoices and amounts are visible to your company's admins.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-white mb-3">Your team in {formatMonthLong(period.month)}</h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <StatTile
            label="Seats on your team"
            value={team.seats.toLocaleString()}
            comparisonLabel={`You and ${plural(team.seats_by_role.inspector, 'inspector')}`}
            caption={team.pending_seats ? `${plural(team.pending_seats, 'invite')} not accepted yet — not counted` : null}
          />
          <StatTile
            label="Submissions"
            value={team.submissions.toLocaleString()}
            comparisonLabel="first filings this month"
            caption={team.resubmissions ? `${plural(team.resubmissions, 're-submission')} on top, which are free` : 'Re-submissions are free'}
          />
          <StatTile
            label="Guest submissions"
            value={team.guest_submissions.toLocaleString()}
            comparisonLabel="from one-time accounts you sent"
          />
          <StatTile
            label="Guest passes open"
            value={team.guest_passes_open.toLocaleString()}
            comparisonLabel="one-time accounts not used yet"
            caption="Each becomes a guest submission when it's filled in."
          />
        </div>
      </div>
    </div>
  );
};

export default TeamUsageView;
